import * as React from "react";
import {cva, type VariantProps} from "class-variance-authority";

import {cn} from "@/lib/utils";

const IconVariants = cva(
  "inline-flex rounded-full font-medium border rounded items-center justify-center shrink-0",
  {
    variants: {
      variant: {
        default: "",
        rounded: "rounded-full",
      },
      size: {
        default: "w-10 h-10",
        tiny: "w-4 h-4",
        lg: "w-16 h-16",
        xl: "w-20 h-20",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface IconProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof IconVariants> {
  asChild?: boolean;
}

const Icon = React.forwardRef<HTMLDivElement, IconProps>(
  ({className, variant, size, asChild = false, ...props}, ref) => {
    return (
      <div
        className={cn(IconVariants({variant, size, className}))}
        ref={ref}
        {...props}
      />
    );
  },
);
Icon.displayName = "Icon";

export {Icon, IconVariants};
